import React from 'react';
import { Wrapper, Container } from './style';
import { Toast } from 'antd-mobile';

class Account1 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      typeList: [
        {name: '银行卡',value: '1'},
        {name: '支付宝',value: '2'}
      ],
      typeValue: null,
    }
  }
  async componentDidMount() {
    document.title = '提现账户'
  }
  goAdd(index){
    let typeValue = this.state.typeList[index].value
    this.setState({typeValue})
    this.props.history.push(`/account2/${typeValue}`)
  }
  render() {
    let { typeList,typeValue } = this.state;
    return (
      <Wrapper>
        <Container>
        <div className="list">
          {typeList.map((v, i) => (
            <div className="item" key={`typeList-key-${i}`} onClick={() => this.goAdd(i)}>
              <i className={`${typeValue==v.value?'active':''}`}><b></b></i>
              <span>{v.name}</span>        
            </div>
          ))}
        </div>
        </Container>
      </Wrapper>
    );
  }
}
export default Account1;